import { imagePicker_template } from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { imageWidget_template } from "./imageWidget_template";
import {imagePickerHelper} from '../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper';

declare var ko: any;

export class menuList_template extends vnTemplate {

    // @TODO make this configurable
    readonly disallowedSubItemMenus: string[] = ['footer','header']; // menus with the names listed in this array will not be allowed the 'add sub item' button
    
    public imagePicker :imagePicker_template;
    public imageWidgetForBrandTagImage : imageWidget_template;
    public imagePickerHelper: imagePickerHelper;

    protected getTemplateHtml(): string {
        return /*html*/`
                <div class="list-header w-justify">
                    <div class="w-left">
                        <button class="btn secondary" data-bind="event: {click : $root.menuList.onBackAction }">Back to Menu list</button>
                        <button class="btn secondary" data-bind="visible: items().length == 0, event: {click : $root.menuList.onClickShowAddItem }">Add Root Item</button>
                    </div>
                </div>
                <div class="list-header w-justify">
                    <div class="w-center">
                        <div class="w-nav-prev">
                            <label class="form-label">Navigation Preview</label>
                            <ul data-bind="template: { name: 'item-preview-template', foreach: $root.menuList.subItemsOf(null) }"></ul>
                        </div>
                    </div>
                </div>
                <script id="item-preview-template" type="text/html">
                <li data-bind="css: { 'icon i-dropdown': $root.menuList.hasSubItems($data)}">
                    <span data-bind="text: label"></span>
                    <ul data-bind="template: {name: 'item-preview-template', foreach: $root.menuList.subItemsOf($data)}"></ul>
                </li>
                </script>
                
                <!-- ko if: pageId() == 4 && (permissions()['menu_config_site'] && permissions()['menu_config_site'].read) -->
                        <div class="form-group">
                            <input type="radio" id="trending-style" name="radio-group" value="trending" data-bind="checked: menuStyle">
                            <label class="form-label" style="margin-right:1rem;" for="trending-style" data-bind="event: { click: onClickTrendingStyle }">Trending Style</label>
        
                            <input type="radio" id="topic-division-style" name="radio-group" value="topic" data-bind="checked: menuStyle">
                            <label class="form-label" for="topic-division-style" >Topic Division Style</label>
                            
                        </div>  
                <!-- /ko -->                     
                <div class="nav-builder w-form w-form-large">
                    <div data-bind="template: { name: 'item-template', foreach: $root.menuList.subItemsOf(null) }"></div>
                    <div class="form-footer">                
                        <button data-bind="event: { click: onClickCancel }" class="btn " type="button">Cancel</button>
                        <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>                    
                    </div>
                </div>

                <script id="item-template" type="text/html">
                    
                    <div data-bind="visible: $data.showAddBefore" class="nav-builder-add w-justify">
                        <div class="w-left">
                            <input placeholder="label" class="input-text" type="text" name="" data-bind="attr: { id: 'addBeforeLabel_' + $data.id }">
                            <input placeholder="URL" class="input-text" type="text" name="" data-bind="attr: { id: 'addBeforeUrl_' + $data.id }">
                            <input placeholder="permalinkPartMatch" class="input-text" type="text" name="" data-bind="attr: { id: 'addBeforePermalinkPartMatch_' + $data.id }">
                            <div class="w-form-check-inline">
                                <div class="form-check-inline width-auto" data-bind="visible: $parent.canSetSection">
                                    <input type="checkbox" value="0" data-bind="checked: $data.isSection, attr : { id : 'addBeforeIsSection_'+$data.id , name : 'addBeforeIsSection_'+$data.id }"/>
                                    <label class="form-label icon i-check" data-bind="attr : { 'for' : 'addBeforeIsSection_' + $data.id }">Section title</label>
                                </div>
                            </div>
<!--                            <div class="w-form-check-inline">-->
<!--                                <div class="form-check-inline width-auto">-->
<!--                                    <input type="radio" value="standard" data-bind="attr : { id : 'addBeforeStylingStandard_' + $data.id , name : 'addBeforestyleType_' + $data.id }"/>-->
<!--                                    <label class="form-label" data-bind="attr : { 'for' : 'addBeforeStylingStandard_' + $data.id }">Standard Styling</label>-->
<!--                                </div>-->
<!--                                <div class="form-check-inline width-auto">-->
<!--                                    <input type="radio" value="emphasized" data-bind="attr : { id : 'addBeforeStylingEmphasized_' + $data.id, name : 'addBeforestyleType_' + $data.id  }" />-->
<!--                                    <label class="form-label" data-bind="attr : { 'for' : 'addBeforeStylingEmphasized_' + $data.id }">Emphasized Styling</label>-->
<!--                                </div>-->
<!--                            </div>   -->
                                                     
                            <button data-bind="event: { click: $root.menuList.onClickHideAddBefore }" class="btn highlight only-icon icon i-close" type="button"></button>
                            <button data-bind="event: { click: $root.menuList.onClickAddBefore }" class="btn only-icon border icon i-check" type="button"></button>
                        </div>
                    </div>
                    
                    <div class="nav-builder-entry draggable" draggable="true" data-bind="attr: { id: 'draggableMenuItem_' + id }">  
                    <!--<div class="nav-builder-entry">-->
                        
                        
                       <!-- ko if: $data.showEdit -->
                       <div class="nav-builder-add w-justify">
                            <div class="w-left">
                            
                                <input placeholder="label" class="input-text" type="text" name="" data-bind="value: tmplabel, attr: { id: 'editLabel_' + id }">
                                <input placeholder="URL" class="input-text" type="text" name="" data-bind="value: tmpurl, attr: { id: 'editUrl_' + id }"> 
                                <div class="w-form-check-inline">
                                <div class="form-check-inline width-auto" data-bind="visible: $parent.canSetSection">
                                    <input type="checkbox" value="0" data-bind=" checked: isSection, attr : { id : 'editIsSection_' + id , name : 'editIsSection_'+id }"/>
                                    <label class="form-label icon i-check" data-bind="attr : { 'for' : 'editIsSection_' + id }">Section title</label>
                                </div>
                            </div>
                                <!-- Styling on Edition -->
                                <div class="w-form-check-inline" data-bind="visible: !$data.idParent && $parent.canSetStyling">
                                    <div class="form-check-inline width-auto">
                                        <input type="radio" value="standard" data-bind="checked: tmpStyle, attr : { id : 'editStylingStandard_' + id , name : 'styleType_' + id }"/>
                                        <label class="form-label" data-bind="attr : { 'for' : 'editStylingStandard_' + id }">Standard Styling</label>
                                    </div>
                                    <div class="form-check-inline width-auto">
                                        <input type="radio" value="emphasized" data-bind="checked: tmpStyle, attr : { id : 'editStylingEmphasized_' + id, name : 'styleType_' + id  }" />
                                        <label class="form-label" data-bind="attr : { 'for' : 'editStylingEmphasized_' + id }">Emphasized Styling</label>
                                    </div>
                                </div>                         
                                <button data-bind="event: { click: $root.menuList.onClickHideEdit }" class="btn highlight highlight only-icon icon i-close" type="button"></button>
                                <button data-bind="event: { click: $root.menuList.onClickEdit }" class="btn only-icon border icon i-check" type="button"></button>
                            </div>
                        </div>
                       <!-- /ko -->
                       
                       <!-- ko ifnot: $data.showEdit -->
                       
                       <div class="w-justify" data-bind="event: {mouseenter: $root.menuList.showActions, mouseleave:  $root.menuList.hideActions}">
                            
                            
                            <div class="w-left" >
                                <span class="icon i-drag"></span>
                                <span class="btn no-bg child icon i-return"></span>
                                <span style="display:flex;">
                                    
                                    <div class="btn no-bg child icon" data-bind="css: { 'i-image': image }"></div>
                                    <strong class="nav-builder-label" data-bind="text: label"></strong>
                                </span>
                                <span class="nav-builder-slug" data-bind="text: url"></span>
                                
                                <span class="nav-builder-label" data-bind="text: permalinkPartMatch, visible: permalinkPartMatch"></span>
                                    
                                <div class="w-form-check-inline">
                                <div class="form-check-inline width-auto" data-bind="visible: $parent.canSetSection">
                                    <input type="checkbox" data-bind="attr : { id : 'showIsSection_' + id , name : 'showIsSection_'+id }, checked: isSection" disabled/>
                                    <label class="form-label icon i-check" data-bind="attr : { 'for' : 'showIsSection_' + id }">Section title</label>
                                </div>
                            </div>
                                <!--Read only-->
                                <div class="w-form-check-inline" data-bind="visible: (!$data.idParent || $root.menuList.rootItems().indexOf($data.idParent) != -1) && $root.menuList.canSetStyling">
                                    <div class="form-check-inline width-auto">
                                        <input type="radio" value="standard" data-bind="checked: tmpStyle, attr : { id : 'showStylingStandard_' + id , name : 'showstyleType_' + id }" disabled/>
                                        <label class="form-label" data-bind="attr : { 'for' : 'showStylingStandard_' + id }">Standard Styling</label>
                                    </div>
                                    <div class="form-check-inline width-auto">
                                        <input type="radio" value="emphasized" data-bind="checked: tmpStyle, attr : { id : 'showStylingEmphasized_' + id, name : 'showstyleType_' + id  }" disabled />
                                        <label class="form-label" data-bind="attr : { 'for' : 'showStylingEmphasized_' + id }">Emphasized Styling</label>
                                    </div>
                                </div>  
                            </div>
                            
                            
                            
                            <div class="w-right">

                                <div data-bind="css: { 'is-showing': $root.menuList.showActionId() == $data.id }" class="add-btn ">
                                    <button data-bind="event: { click: $root.menuList.onClickShowAddBefore }" class="btn no-bg icon before i-add-before">Add before</button>
                                    <button data-bind="event: { click: $root.menuList.onClickShowAddAfter }" class="btn no-bg  icon i-add-after">Add after</button>
                                     
                                    <!-- ko if: $root.menuList.canAddChild($data) -->
                                        <button data-bind="event: { click: $root.menuList.onClickShowAddChild }" class="btn no-bg  icon i-return">Add Sub-item</button>
                                     <!-- /ko -->
                                    
                                </div> 
                                <button data-bind="event: { click: $root.menuList.onClickShowEdit}" class="btn only-icon icon i-edit" type="button"></button>
                                <button data-bind="event: { click: $root.menuList.onClickSoftDelete }" class="btn only-icon icon i-delete" type="button"></button>
                            </div>
                        </div>
                       
                        <!-- /ko -->
                        
                        <!-- ko if: $root.menuList.hasSubItems($data) -->
                            <div class="nav-builder-entry-children" data-bind="template: {name: 'item-template', foreach: $root.menuList.subItemsOf($data)}"></div>        
                        <!-- /ko -->
                        
                        <!-- ko ifnot: $root.menuList.hasSubItems($data) -->
                            <div data-bind="visible: $data.showAddChild" class="nav-builder-entry">
                                <div class="nav-builder-add w-justify">
                                    <div class="w-left">
                                        
                                        <input placeholder="label" class="input-text" type="text" name="" data-bind="attr: { id: 'addChildLabel_' + id }">
                                        <input placeholder="URL" class="input-text" type="text" name="" data-bind="attr: { id: 'addChildUrl_' + id }">
                                        
                                        <div class="w-form-check-inline">
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" value="standard" data-bind=" attr : { id : 'childStylingStandard_' + id , name : 'childstyleType_' + id }"/>
                                                <label class="form-label" data-bind="attr : { 'for' : 'childStylingStandard_' + id }">Standard Styling</label>
                                            </div>
                                            <div class="form-check-inline width-auto">
                                                <input type="radio" value="emphasized" data-bind=" attr : { id : 'childStylingEmphasized_' + id, name : 'childstyleType_' + id  }" />
                                                <label class="form-label" data-bind="attr : { 'for' : 'childStylingEmphasized_' + id }">Emphasized Styling</label>
                                            </div>
                                        </div>   
                                        
                                                               
                                        <button data-bind="event: { click: $root.menuList.onClickHideAddChild }" class="btn highlight only-icon icon i-close" type="button"></button>
                                        <button data-bind="event: { click: $root.menuList.onClickAddChild }" class="btn only-icon border icon i-check" type="button"></button>
                                    </div>
                                </div>
                            </div>        
                        <!-- /ko -->
                        
                    </div>
                    
                    <div data-bind="visible: $data.showAddAfter" class="nav-builder-add w-justify">
                        <div class="w-left">
                            
                            <input placeholder="label" class="input-text" type="text" name="" data-bind="attr: { id: 'addAfterLabel_' + id }">
                            <input placeholder="URL" class="input-text" type="text" name="" data-bind="attr: { id: 'addAfterUrl_' + id }">  
                            <div class="w-form-check-inline">
                                <div class="form-check-inline width-auto" data-bind="visible: $parent.canSetSection">
                                    <input type="checkbox" value="0" data-bind=" checked: isSection, attr : { id : 'addAfterIsSection_'+id , name : 'addAfterIsSection_'+id }"/>
                                    <label class="form-label icon i-check" data-bind="attr : { 'for' : 'addAfterIsSection_' + id }">Section title</label>
                                </div>
                            </div>
<!--                            <div class="w-form-check-inline">-->
<!--                                <div class="form-check-inline width-auto">-->
<!--                                    <input type="radio" value="standard" data-bind="attr : { id : 'addAfterStylingStandard_' + id , name : 'addAfterstyleType_' + id }"/>-->
<!--                                    <label class="form-label" data-bind="attr : { 'for' : 'addAfterStylingStandard_' + id }">Standard Styling</label>-->
<!--                                </div>-->
<!--                                <div class="form-check-inline width-auto">-->
<!--                                    <input type="radio" value="emphasized" data-bind="attr : { id : 'addAfterStylingEmphasized_' + id, name : 'addAfterstyleType_' + id  }" />-->
<!--                                    <label class="form-label" data-bind="attr : { 'for' : 'addAfterStylingEmphasized_' + id }">Emphasized Styling</label>-->
<!--                                </div>-->
<!--                            </div>   -->
                            
                                                    
                            <button data-bind="event: { click: $root.menuList.onClickHideAddAfter }" class="btn highlight only-icon icon i-close" type="button"></button>
                            <button data-bind="event: { click: $root.menuList.onClickAddAfter }" class="btn only-icon border icon i-check" type="button"></button>
                        </div>
                    </div>
               
                </script>
                
                                
                <!-- Confiration Form --> 
                <div data-bind="if: $root.menuList.deleteConfirmation()" class="w-form sticky">
                    <!-- ko with: deleteConfirmation() -->
                    <div class="form-header">
                        <h3 class="form-title icon i-edit">Delete &nbsp;<span data-bind="text: label"></span></h3>
                    </div>
                    <form class="form-body">
                        <div class="form-group">
                            <p>Are you sure you want to delete <span  data-bind="text: label"></span> and all it's sub-menu.</p>
                        </div>
                         <div class="form-footer">                
                            <button data-bind="event: { click: $root.menuList.onClickHardDelete }" class="btn highlight" type="button">Delete</button>
                            <button data-bind="event: { click: $root.menuList.onClickCancelSoftDelete }" class="btn " type="button">Cancel</button>            
                         </div>
                       
                    </form>
                    <!-- /ko -->                   
                </div>
                
                <div data-bind="css: { 'is-visible': showAddForm }" class="w-lightbox light-theme show-hide-columns-lightbox">
                        <div class="lightbox-content">
                            <div class="w-form lightbox-form">
                                <div class="form-header">
                                    <h3 class="form-title">Add Menu Item</h3>
                                </div>
                                
                                <div class="form-body">
                                    <div class="form-group">
                                            <input placeholder="label" class="input-text" type="text" name="" id="addRootLabel">
                                        </div>
                                        <div class="form-group">
                                            <input placeholder="URL" class="input-text" type="text" name="" id="addRootUrl">
                                        </div>
                                        <div class="form-group" data-bind= "visible: menuStyle() == 'topic'">
                                            <input placeholder="permalinkPartMatch" class="input-text" type="text" name="" id="addRootPermalinkPartMatch">
                                        </div> 
                                        
                                        <div class="form-group" data-bind="visible: siblingParent() == null  && canSetSection">
                                                <input type="checkbox" value="0" data-bind="attr : { id : 'addRootIsSection_new' , name : 'addRootIsSection_new' }"/>
                                                <label class="form-label icon i-check" data-bind="attr : { 'for' : 'addRootIsSection_new' }">Section title</label>
                                        </div>
                                        <div class="form-group" data-bind="visible: (siblingParent() == null || rootItems().indexOf(siblingParent()) != -1) && canSetStyling">
                                                <input type="radio" value="standard" data-bind="attr : { id : 'addRootStylingStandard_new' , name : 'addRootStylingStandard_new' }" checked/>
                                                <label class="form-label" data-bind="attr : { 'for' : 'addRootStylingStandard_new' }">Standard Styling</label>
                                                <input type="radio" value="emphasized" data-bind="attr : { id : 'addRootStylingEmphasized_new', name : 'addRootStylingStandard_new'  }" />
                                                <label class="form-label" data-bind="attr : { 'for' : 'addRootStylingEmphasized_new'  }">Emphasized Styling</label>
                                        </div>   
                                        <div class="form-group img" data-bind="visible: menuStyle() == 'topic'">    
                                            ${ this.imageWidgetForBrandTagImage.getHtmlBuild() }                                        
                                        </div>
                                </div>
                                
                                <div class="form-footer">
                                    <button type="button" data-bind="event: { click: onClickAddItem}" class="btn highlight">Apply</button>
                                    <button type="button" data-bind="event: { click: onClickHideAddItem.bind($data, false)}" class="btn ">Cancel</button>
                                </div>
                            </div>
                        </div> 
                        ${ this.imagePicker.getHtmlBuild() }                       
                    </div>
                    
                    

                `;
    }

    protected getTemplateName(): string {
        return "menuList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large", "form-create-tag"];
    }

    protected buildViewModel(): any {

        let huit_neuf_this = this;
        return {
            subItemsOf: function (value, data, event) {
                return huit_neuf_this.subItemsOf(value);
            },
            hasSubItems: function (value, data, event) {
                return huit_neuf_this.hasSubItems(value);
            },
            canAddChild: function (value, data, event) {
                return huit_neuf_this.canAddChild(value);
            },
            onClickAddRootChild: function () {
                return huit_neuf_this.onClickAddRootChild();
            },
            onClickAddChild: function (data, event) {
                return huit_neuf_this.onClickAddChild(data);
            },
            onClickShowAddBefore: function (data, event) {
                return huit_neuf_this.onClickShowAddBefore(data);
            },
            onClickShowAddAfter: function (data, event) {
                return huit_neuf_this.onClickShowAddAfter(data);
            },
            onClickShowAddChild: function (data, event) {
                return huit_neuf_this.onClickShowAddChild(data);
            },
            onClickHideAddBefore: function (data, event) {
                return huit_neuf_this.onClickHideAddBefore(data);
            },
            onClickHideAddItem: function (data, event) {
                return huit_neuf_this.onClickHideAddItem(data);
            },
            onClickHideAddAfter: function (data, event) {
                return huit_neuf_this.onClickHideAddAfter(data);
            },
            onClickHideAddChild: function (data, event) {
                return huit_neuf_this.onClickHideAddChild(data);
            },
            onClickAddBefore: function (data, event) {
                return huit_neuf_this.onClickAddBefore(data);
            },
            onClickAddItem: function (data, event) {
                return huit_neuf_this.onClickAddItem(data);
            },
            onClickShowAddItem: function (data, event) {
                return huit_neuf_this.onClickShowAddItem(data);
            },
            onClickAddAfter: function (data, event) {
                return huit_neuf_this.onClickAddAfter(data);
            },
            onClickHideEdit: function (data, event) {
                return huit_neuf_this.onClickHideEdit(data);
            },
            onClickShowEdit: function (data, event) {
                return huit_neuf_this.onClickShowEdit(data);
            },
            onClickEdit: function (data, event) {
                return huit_neuf_this.onClickEdit(data);
            },
            onClickSoftDelete: function (data, event) {
                return huit_neuf_this.onClickSoftDelete(data);
            },
            onClickCancelSoftDelete: function () {
                return huit_neuf_this.onClickCancelSoftDelete();
            },
            onClickHardDelete: function (data, event) {
                return huit_neuf_this.onClickHardDelete(data);
            },
            onClickSave: function (data, event) {
                huit_neuf_this.onClickSave();
            },
            onClickCancel: function (data, event) {
                huit_neuf_this.onClickCancel();
            },
            showActions: function (data, event) {
                huit_neuf_this.showActions(data);
            },
            hideActions: function (data, event) {
                huit_neuf_this.hideActions(data);
            },
            onBackAction: function (data, event) {
                huit_neuf_this.onBackAction();
            },
            onClickTrendingStyle: function (data, event) {
                huit_neuf_this.onClickTrendingStyle(data,event);
            },
            items: ko.observableArray([]),
            itemsToDelete: ko.observableArray([]),
            maxId: ko.observable(0),
            menuName: ko.observable(''),
            showActionId: ko.observable(null),
            deleteConfirmation: ko.observable(null),
            canSetSection: ko.observable(false),
            canSetStyling: ko.observable(false),
            showAddForm: ko.observable(false),
            addPosition: ko.observable(null),
            siblingOrder: ko.observable(null),
            siblingParent: ko.observable(null),
            itemId: ko.observable(null),
            rootItems: ko.observableArray(null),
            menuStyle: ko.observable(null),
            pageId: ko.observable(null),
            permissions : ko.observableArray(this.initPermissions(['menu_config_site', 'menu_config_footer'])),
        }
    };

    protected initPartial(): void {

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        
        this.imagePickerHelper = new imagePickerHelper(
            this.imagePicker,
            this.caller.viewModel, 
            this.caller.getVnAppZone(),
            this.caller
        );
        this.imageWidgetForBrandTagImage = new imageWidget_template('menu_image', this.getTemplateViewModel(), this);
        this.imageWidgetForBrandTagImage.setMode('single-select');
        this.imageWidgetForBrandTagImage.setCaller(this.imagePickerHelper);

    }

    public subItemsOf(item) {

        return ko.utils.arrayFilter(this.getTemplateViewModel().items(), function (arrayItem) {
            const parentItemId = (null === item) ? null : item.id;
            return arrayItem.idParent == parentItemId;
        });
    }

    public onClickShowAddBefore(data) {

        this.getTemplateViewModel().siblingOrder(data.order ? data.order : 1);
        this.getTemplateViewModel().siblingParent(data.idParent);
        this.getTemplateViewModel().addPosition('before');
        this.getTemplateViewModel().showAddForm(true);
    }

    public onClickShowAddItem(data) {

        let addPosition = 'before';
        if(data.addPosition){
            addPosition =  data.addPosition;
        }
        this.getTemplateViewModel().addPosition(addPosition);
        this.getTemplateViewModel().siblingOrder(data.order ? data.order : 1);
        this.getTemplateViewModel().siblingParent(data.idParent);
        this.getTemplateViewModel().showAddForm(true);
    }

    public onClickShowAddAfter(data) {

        this.getTemplateViewModel().siblingOrder(data.order ? data.order : 1);
        this.getTemplateViewModel().siblingParent(data.idParent);
        this.getTemplateViewModel().addPosition('after');
        this.getTemplateViewModel().showAddForm(true);
    }

    public onClickShowAddChild(data) {

        this.getTemplateViewModel().siblingOrder(data.order ? data.order : 1);
        this.getTemplateViewModel().siblingParent(data.id);
        this.getTemplateViewModel().addPosition('after');
        this.getTemplateViewModel().showAddForm(true);
    }

    public onClickHideAddItem(data?) {

        this.getTemplateViewModel().showAddForm(false);
        (<HTMLInputElement>document.getElementById("addRootLabel")).value = '';
        (<HTMLInputElement>document.getElementById("addRootUrl")).value = '';
        (<HTMLInputElement>document.getElementById("addRootPermalinkPartMatch")).value = '';
        (<HTMLInputElement>document.querySelector(`[name=addRootStylingStandard_new]:checked`)).value = 'standard';
        (<HTMLInputElement>document.querySelector(`[name=addRootIsSection_new]`)).checked = false;
        this.imageWidgetForBrandTagImage.clearImage();
        this.onLoadTemplate('.draggable', this);
    }

    public onClickHideAddAfter(data) {

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == data.id) {
                item.showAddAfter = false;
            }
        }

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.onLoadTemplate('.draggable', this);

    }

    public onClickHideAddBefore(data) {

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == data.id) {
                item.showAddBefore = false;
            }
        }

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.onLoadTemplate('.draggable', this);

    }

    public onClickHideAddChild(data) {

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == data.id) {
                item.showAddChild = false;
            }
        }

        this.getTemplateViewModel().items([]);

        this.getTemplateViewModel().items(items);
        this.onLoadTemplate('.draggable', this);
    }

    public onClickTrendingStyle(data,event) {
        //we are going to remove all the child items
        let items = this.getTemplateViewModel().items();
        
        // Filter out items with idParent
        let filteredItems = items.filter(item => !item.idParent);
        let deletedItems = items.filter(item => item.idParent && item.id !== null);
        filteredItems.forEach(item => {
            
            if(item.image || item.permalinkPartMatch){
                item.image = null;
                item.permalinkPartMatch = null;
            }
        });
        this.getTemplateViewModel().itemsToDelete(deletedItems);
        // Update the items array
        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(filteredItems);
        this.getTemplateViewModel().menuStyle(null);
        this.getTemplateViewModel().menuStyle('trending');
    }

    public onClickAddRootChild() {
        let maxId = this.getTemplateViewModel().maxId();
        let items = this.getTemplateViewModel().items();

        let idParent = this.getTemplateViewModel().itemLocationParent()

        let label = (<HTMLInputElement>document.getElementById("addRootLabel")).value;
        let url = (<HTMLInputElement>document.getElementById("addRootUrl")).value;
        let permalinkPartMatch :string = (<HTMLInputElement>document.getElementById("addRootPermalinkPartMatch")).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=addRootStylingStandard_new]:checked`)).value;
        let isSection = (<HTMLInputElement>document.querySelector(`[name=addRootIsSection_new]`)).checked;

        maxId = maxId + 1;
        items.push({
            id: maxId,
            label: label,
            url: url,
            permalinkPartMatch:permalinkPartMatch,
            isSection: isSection,
            tmplabel: label,
            tmpurl: url,
            idParent: idParent,
            order: 1,
            showAddBefore: false,
            showAddAfter: false,
            showAddChild: false,
            showEdit: false,
            tmpStyle: styleType
        });
        items.sort(this.sortMenu);

        this.getTemplateViewModel().itemLocationId(null)
        this.getTemplateViewModel().itemLocationParent(null)
        this.getTemplateViewModel().insertPosition(null)

        this.getTemplateViewModel().items([]);

        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.onLoadTemplate('.draggable', this);

    }

    public onClickAddItem(data) {
        let maxId = this.getTemplateViewModel().maxId();
        let items = this.getTemplateViewModel().items();
        let label = (<HTMLInputElement>document.getElementById("addRootLabel")).value;
        let url = (<HTMLInputElement>document.getElementById("addRootUrl")).value;
        let permalinkPartMatch :string = (<HTMLInputElement>document.getElementById("addRootPermalinkPartMatch")).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=addRootStylingStandard_new]:checked`)).value;
        let isSection = (<HTMLInputElement>document.querySelector(`[name=addRootIsSection_new]`)).checked;

        this.validateUrl(url, isSection);

        let image = this.imageWidgetForBrandTagImage.getImage();

        console.log(styleType)

        let newOrder = 0;
        if(this.getTemplateViewModel().addPosition()) {

            if (this.getTemplateViewModel().addPosition() == "before") {
                newOrder = this.getTemplateViewModel().siblingOrder();

            } else {
                newOrder = this.getTemplateViewModel().siblingOrder() + 1;
            }
            let itemParent = this.getTemplateViewModel().siblingParent();
            for (let item of items) {
                if (item.idParent == itemParent && item.order >= newOrder) {
                    item.order = item.order + 1;
                }

                if (item.id == data.id) {
                    item.showAddBefore = false;
                }
            }
            if(permalinkPartMatch){
                if (!permalinkPartMatch.startsWith('/')) {
                    permalinkPartMatch = '/' + permalinkPartMatch;
                }
            }
            maxId = maxId + 1;
            items.push({
                id: maxId,
                label: label,
                url: url,
                tmplabel: label,
                isSection: isSection,
                tmpurl: url,
                image: image,
                permalinkPartMatch: permalinkPartMatch,
                idParent: itemParent,
                order: newOrder,
                showAddBefore: false,
                showAddAfter: false,
                showAddChild: false,
                showEdit: false,
                tmpStyle: styleType
            });

            let sameParent = items.filter(e => e.idParent == itemParent);
            sameParent.sort(this.sortMenu);

            let diffParent = items.filter(e => e.idParent != itemParent);

            items = sameParent.concat(diffParent)
        } else {
            let itemId = this.getTemplateViewModel().itemId();
            if(permalinkPartMatch){
                if (!permalinkPartMatch.startsWith('/')) {
                    permalinkPartMatch = '/' + permalinkPartMatch;
                }
                
            }
            for (let item of items) {
                if(item.id == itemId) {
                    item.label = label;
                    item.url = url;
                    item.permalinkPartMatch = permalinkPartMatch;
                    item.image = image;
                    // if(!item.idParent){
                    item.tmpStyle = styleType;
                    item.isSection = isSection;
                    // }
                    break;
                }
            }
        }
        this.getTemplateViewModel().items([]);

        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.getTemplateViewModel().addPosition(null);
        this.getTemplateViewModel().siblingOrder(null);
        this.getTemplateViewModel().siblingParent(null);
        this.getTemplateViewModel().showAddForm(false);

        (<HTMLInputElement>document.getElementById("addRootLabel")).value = '';
        (<HTMLInputElement>document.getElementById("addRootUrl")).value = '';
        (<HTMLInputElement>document.getElementById("addRootPermalinkPartMatch")).value = '';
        (<HTMLInputElement>document.getElementById(("addRootStylingStandard_new"))).checked = true;
        (<HTMLInputElement>document.querySelector(`[name=addRootIsSection_new]`)).checked = false;
        this.onLoadTemplate('.draggable', this);
        this.imageWidgetForBrandTagImage.clearImage();

    }

    public onClickAddBefore(data) {

        let maxId = this.getTemplateViewModel().maxId();
        let items = this.getTemplateViewModel().items();

        let newOrder = data.order;
        for (let item of items) {
            if (item.idParent == data.idParent && item.order >= newOrder) {
                item.order = item.order + 1;
            }

            if (item.id == data.id) {
                item.showAddBefore = false;
            }
        }

        let label = (<HTMLInputElement>document.getElementById("addBeforeLabel_" + data.id)).value;
        let url = (<HTMLInputElement>document.getElementById("addBeforeUrl_" + data.id)).value;
        let permalinkPartMatch = (<HTMLInputElement>document.getElementById("addBeforePermalinkPartMatch_" + data.id)).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=addBeforestyleType_${data.id}]:checked`)).value;

        maxId = maxId + 1;
        items.push({
            id: maxId,
            label: label,
            url: url,
            permalinkPartMatch: permalinkPartMatch,
            isSection: false,
            tmplabel: label,
            tmpurl: url,
            idParent: data.idParent,
            order: newOrder,
            showAddBefore: false,
            showAddAfter: false,
            showAddChild: false,
            showEdit: false,
            tmpStyle: styleType
        });

        items.sort(this.sortMenu)
        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.getTemplateViewModel().addPosition(null);
        this.getTemplateViewModel().siblingOrder(null);
        this.getTemplateViewModel().siblingParent(null);
        this.getTemplateViewModel().showAddForm(false);
        this.onLoadTemplate('.draggable', this);
    }

    public onClickAddAfter(data) {

        let maxId = this.getTemplateViewModel().maxId();
        let items = this.getTemplateViewModel().items();

        let newOrder = data.order + 1;
        for (let item of items) {
            if (item.idParent == data.idParent && item.order >= newOrder) {
                item.order = item.order + 1;
            }

            if (item.id == data.id) {
                item.showAddAfter = false;
            }
        }

        let label = (<HTMLInputElement>document.getElementById("addAfterLabel_" + data.id)).value;
        let url = (<HTMLInputElement>document.getElementById("addAfterUrl_" + data.id)).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=addAfterstyleType_${data.id}]:checked`)).value;

        maxId = maxId + 1;
        items.push({
            id: maxId,
            label: label,
            url: url,
            isSection: false,
            tmplabel: label,
            tmpurl: url,
            idParent: data.idParent,
            order: newOrder,
            showAddBefore: false,
            showAddAfter: false,
            showAddChild: false,
            showEdit: false,
            tmpStyle: styleType
        });
        items.sort(this.sortMenu);

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.getTemplateViewModel().addPosition(null);
        this.getTemplateViewModel().siblingOrder(null);
        this.getTemplateViewModel().siblingParent(null);
        this.getTemplateViewModel().showAddForm(false);
        this.onLoadTemplate('.draggable', this);
    }

    public onClickAddChild(data) {

        let maxId = this.getTemplateViewModel().maxId();
        let items = this.getTemplateViewModel().items();

        let label = (<HTMLInputElement>document.getElementById("addChildLabel_" + data.id)).value;
        let url = (<HTMLInputElement>document.getElementById("addChildUrl_" + data.id)).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=childstyleType_${data.id}]:checked`)).value;

        for (let item of items) {

            if (item.id == data.id) {

                item.showAddChild = false;
            }
        }

        maxId = maxId + 1;
        items.push({
            id: maxId,
            label: label,
            url: url,
            tmplabel: label,
            tmpurl: url,
            idParent: data.id,
            order: 1,
            showAddBefore: false,
            showAddAfter: false,
            showAddChild: false,
            showEdit: false,
            tmpStyle: styleType,
            isSection: false,
        });

        items.sort(this.sortMenu);

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.onLoadTemplate('.draggable', this);

    }

    public onClickShowEdit(data) {

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == data.id) {

                (<HTMLInputElement>document.getElementById("addRootLabel")).value = item.label;
                (<HTMLInputElement>document.getElementById("addRootUrl")).value = item.url;
                if(item.permalinkPartMatch){

                    (<HTMLInputElement>document.getElementById("addRootPermalinkPartMatch")).value = item.permalinkPartMatch;
                }
                if(item.image){
                    this.imageWidgetForBrandTagImage.setImage(item.image);
                }
                let style = (item.tmpStyle.charAt(0).toUpperCase() + item.tmpStyle.slice(1));
                (<HTMLInputElement>document.getElementById(("addRootStyling" + style + "_new"))).checked = true;
                (<HTMLInputElement>document.querySelector(`[name=addRootIsSection_new]`)).checked = item.isSection;

                this.getTemplateViewModel().itemId(data.id);
                this.getTemplateViewModel().siblingOrder(data.order);
                this.getTemplateViewModel().siblingParent(data.idParent);
                this.getTemplateViewModel().showAddForm(true);
                break;
            }
        }

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
    }

    public onClickHideEdit(data) {

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == data.id) {
                item.showEdit = false;
                item.tmplabel = item.label;
                item.tmpurl = item.url;
            }
        }

        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.onLoadTemplate('.draggable', this);
    }

    public onClickEdit(data) {

        let itemId = this.getTemplateViewModel().itemId();
        let items = this.getTemplateViewModel().items();

        let label = (<HTMLInputElement>document.getElementById("addChildLabel_" + data.id)).value;
        let url = (<HTMLInputElement>document.getElementById("addChildUrl_" + data.id)).value;
        let styleType = (<HTMLInputElement>document.querySelector(`[name=childstyleType_${data.id}]:checked`)).value;

        for (let item of items) {
            if (item.id == data.id) {
                item.label = item.tmplabel;
                item.url = item.tmpurl;
                item.showEdit = false;

            }
        }

        items.sort(this.sortMenu);

        this.getTemplateViewModel().items([]);

        this.getTemplateViewModel().items(items);
        this.onLoadTemplate('.draggable', this);
    }

    public onClickSoftDelete(item) {

        this.getTemplateViewModel().deleteConfirmation(item)
    }

    public onClickCancelSoftDelete() {

        this.getTemplateViewModel().deleteConfirmation(null)
    }

    public onClickHardDelete(itemToDelete) {
        let items_to_delete = this.getTemplateViewModel().itemsToDelete()
        items_to_delete.push(itemToDelete)

        let children = this.subItemsOf(itemToDelete);
        for (let child of children) {
            this.onClickHardDelete(child);
        }

        let items = this.getTemplateViewModel().items();

        for (let item of items) {
            if (item.id == itemToDelete.id) {
                let index = items.findIndex(items => items.id == item.id);
                if (index != -1) {
                    items.splice(index, 1);
                }
            }

        }
        this.getTemplateViewModel().items([]);
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().itemsToDelete(items_to_delete)
        this.getTemplateViewModel().deleteConfirmation(null);
        this.onLoadTemplate('.draggable', this);
    }

    public showActions(data) {

        this.getTemplateViewModel().showActionId(data.id);
    }

    public hideActions(data) {

        this.getTemplateViewModel().showActionId(null);
    }

    public hasSubItems(item) {
        var firstMatch = ko.utils.arrayFirst(this.getTemplateViewModel().items(), function (arrayItem) {
            return (arrayItem.idParent == item.id);
        });
        return (null !== firstMatch && typeof firstMatch !== "undefined"); // At least one item found in array
    }

    public canAddChild(item) {

        let allowed: boolean = true;
        let menuName = this.getTemplateViewModel().menuName();

        // don't allow the add child button for any menus set in the disallowedSubItemMenus array
        if (typeof menuName !== "undefined") {
            this.disallowedSubItemMenus.forEach(menuItem => {
                if (menuItem == menuName && this.getTemplateViewModel().menuStyle() == "trending") {
                    allowed = false;
                }
            });
        }

        return allowed;
    }

    public setMenuItems(menuItems,maxId,menuStyle) {

        let items = [];
        let rootItems = [];
        let uniqueId = 0;
        let menuName = '';

        for (let [index, item] of menuItems.entries()) {
            // if (maxId < item.id) {
            //     maxId = item.id;
            // }

            // all the items in this menu should have the same menu name, so setting the last
            if ((typeof item.menu !== 'undefined') && (typeof item.menu.name !== 'undefined')) {
                menuName = item.menu.name;
            }

            if(item.idParent == null){
                rootItems.push(item.id);
            }
            if(!item.permalinkPartMatch){
                item.permalinkPartMatch = '';
            }
            items.push({
                id: item.id,
                label: item.label,
                url: item.url,
                permalinkPartMatch: item.permalinkPartMatch,
                tmplabel: item.label,
                tmpurl: item.url,
                idParent: item.idParent,
                order: item.order,
                image: item.image,
                showAddBefore: false,
                showAddAfter: false,
                showAddChild: false,
                showEdit: false,
                showActionas: false,
                uniqueId: index,
                tmpStyle: item.styleType,
                isSection: item.isSection,

            });
        }

        items.sort(this.sortMenu);

        this.getTemplateViewModel().rootItems([])
        this.getTemplateViewModel().rootItems(rootItems)
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().maxId(maxId);
        this.getTemplateViewModel().menuName(menuName);
        let canSetSection = (menuName == 'site' ? true : false)
        let canSetStyling = (menuName == 'site' ? true : false)
        this.getTemplateViewModel().canSetSection(canSetSection);
        this.getTemplateViewModel().canSetStyling(canSetStyling);
        this.getTemplateViewModel().itemsToDelete([]);
        this.getTemplateViewModel().pageId(menuItems[0].idMenu);

        this.getTemplateViewModel().menuStyle(menuStyle);

        this.onLoadTemplate('.draggable', this);

    }

    public sortMenu(a, b) {

        var o1 = a['idParent'];
        var o2 = b['idParent'];

        var p1 = a['order'];
        var p2 = b['order'];

        if (o1 < o2) return -1;
        if (o1 > o2) return 1;
        if (p1 < p2) return -1;
        if (p1 > p2) return 1;
        return 0;
    }

    protected onClickSave() {

        this.caller.save();
    }

    protected onClickCancel() {

        this.caller.cancel();
    }

    public onBackAction() {
        this.caller.backAction();
    }

    public getAncestors(id){
        let huit_neuf_this = this;

        let ancestors = [];
        let items = huit_neuf_this.getTemplateViewModel().items();

        let parent = items.find(e => e.id == id);
        if(parent && parent.idParent != null){

            let ances = this.getAncestors(parent.idParent);
            ancestors = ancestors.concat(ances)
            ancestors.push(parent.id)

        } else {
            ancestors.push(id)
        }
        return ancestors;
    }

    private onLoadTemplate(dragItemSelector, huit_neuf) {

        var dragSrcEl = null;
        var dragSrcId = null;
        var dragItemIdPrefix = "draggableMenuItem_";

        function handleDragStart(e) {

            // @TODO: remove any elements visible because the dragged element was hovered

            if (e.stopPropagation) {
                e.stopPropagation(); // Prevent the parent item from being considered the dragged item
            }

            // Target (this) element is the source node.
            dragSrcEl = this;
            dragSrcId = e.srcElement.id;

            // hide actions
            huit_neuf.hideActions(null);

            //e.dataTransfer.setData('text', 'foo');
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('text/html', this.outerHTML);

            this.classList.add('dragElem');
        }

        function handleDragOver(e) {

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            if (e.stopPropagation) {
                e.stopPropagation(); // Prevent the parent/child element from both being 'dragged over' simultaneously
            }

            let huit_neuf_this = this;
            //var dragItems = document.querySelectorAll('[draggable=true]');
            var dragItems = document.querySelectorAll(dragItemSelector);
            let index = 0;
            let found = false;
            for (let item of dragItems) {

                if (dragSrcEl == item) {

                    huit_neuf_this.classList.add('after');
                    huit_neuf_this.classList.remove('before');
                    found = true;
                    break;
                }
                if (this == item) {

                    huit_neuf_this.classList.add('before');
                    huit_neuf_this.classList.remove('after');
                    found = true;
                    break;
                }
            }

            if (!found) {
                this.classList.add("before");
            }

            e.dataTransfer.dropEffect = 'move';  // See the section on the DataTransfer object.

            return false;
        }

        function handleDragEnter(e) {

            // this / e.target is the current hover target.
            this.classList.add('over');
            this.classList.add('before');
        }

        function handleDragLeave(e) {

            this.classList.remove('before');
            this.classList.remove('after');  // this / e.target is previous target element.
        }

        function handleDrop(e) {

            // @TODO not type safe in here..

            // this/e.target is current target element.

            if (e.stopPropagation) {
                e.stopPropagation(); // Stops some browsers from redirecting.
            }

            if (e.preventDefault) {
                e.preventDefault(); // Necessary. Allows us to drop.
            }

            // Don't do anything if dropping the same column we're dragging.
            if (dragSrcEl != this) {

                //let success = true;
                let items = huit_neuf.getTemplateViewModel().items();
                let destinationID = this.id;
                let dragSrcIdInt = parseInt(dragSrcId.substring(dragItemIdPrefix.length)); // integer id of the element that was dragged..
                destinationID = (destinationID.indexOf(dragItemIdPrefix) >= 0) ? parseInt(destinationID.substring(dragItemIdPrefix.length)) : null; // the destination element ID is the number after "draggableMenuItem_" in the ID or null if the prefix is missing
                let oldElement = document.querySelector('.nav-builder-entry[id=\'' + dragSrcId + '\']');
                //var dropHTML = e.dataTransfer.getData('text/html'); // @TODO remove dataTransfer?
                let dropHTML = oldElement.outerHTML;
                let disallowDrop = false;

                let ancestors = huit_neuf.getAncestors(destinationID,);

                if(ancestors.indexOf(dragSrcIdInt) != -1){
                    disallowDrop = true;
                }

                if(disallowDrop){
                    return;
                }
                //remove the element that was dragged
                oldElement.remove();

                if (this.classList.contains("before")) {

                    this.insertAdjacentHTML('beforebegin', dropHTML);
                    var relativePosition = 'before';
                } else {

                    this.insertAdjacentHTML('afterend', dropHTML);
                    var relativePosition = 'after';
                }

                // re-arrange the items in the model based on the new order.
                // loop through to get the necessary data..
                for (let item of items) {

                    if (item.id == dragSrcIdInt) {

                        var popItem = item;
                    }
                    if (item.id == destinationID) {

                        var destItem = item;
                        var parentID = destItem.idParent;
                        var popItemPos = (relativePosition == 'before') ? destItem.order : destItem.order + 1; // if placed before, the moved item will take the destination items position, if moved after it will move to the destination item position plus 1
                    }
                } // end for

                // loop through again to change all the affected entries
                for (let key in items) {

                    if (items[key].id == dragSrcIdInt) {

                        items[key].order = popItemPos;
                        items[key].idParent = parentID;
                    } else if ((items[key].order >= popItemPos) && (items[key].idParent == parentID)) {

                        items[key].order = items[key].order + 1;
                    }
                } // end for

                items.sort(huit_neuf.sortMenu);
                huit_neuf.getTemplateViewModel().items([]);
                huit_neuf.getTemplateViewModel().items(items);
                huit_neuf.onLoadTemplate('.draggable', huit_neuf);

                //} // end if (success == true)

            }

            this.classList.remove('before');
            this.classList.remove('after');
            return false;
        }

        function handleDragEnd(e) {

            // this/e.target is the source node.
            this.classList.remove('before');
            this.classList.remove('after');

            [].forEach.call(cols, function (col) {

                col.classList.remove('before');
                col.classList.remove('after');
            });
        }

        function addDnDHandlers(elem) {

            elem.addEventListener('dragstart', handleDragStart, false);
            elem.addEventListener('dragenter', handleDragEnter, false)
            elem.addEventListener('dragover', handleDragOver, false);
            elem.addEventListener('dragleave', handleDragLeave, false);
            elem.addEventListener('drop', handleDrop, false);
            elem.addEventListener('dragend', handleDragEnd, false);
        }

        var cols = document.querySelectorAll('[draggable=true]');
        //var cols = document.querySelectorAll(dragItemSelector);
        [].forEach.call(cols, addDnDHandlers);
    }

    public setPermissions(permissions){
        //this.getTemplateViewModel().permissions([]);
        this.getTemplateViewModel().permissions(permissions);
    }

    private validateUrl(url: string, isSection = false): void {
        const isEmptyUrl = url.trim().length === 0;
        if (isEmptyUrl) {
            return;
        }

        if (isSection && isEmptyUrl) {
            return;
        }
        const isValidUrl = /^(\/(?!\/)(?!http|https)|https?:\/\/)/.test(url);

        if (!isValidUrl) {
            this.onClickHideAddItem();
            const validation_template = this.caller.validationTemplate;
            const messageString = "URL needs to start with '/', 'http://', or 'https://'.";

            if (validation_template) {
                const message = [
                    {
                        field: "url",
                        label: "URL",
                        messages: [messageString]
                    }
                ];
                validation_template.setMessages(message);
                setTimeout(() => validation_template.clearMessages(), 4000);
            } else {
                console.error(messageString);
            }

            throw new Error(messageString);
        }
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/menuList_template.ts